import { render, staticRenderFns } from "./StreamBackdrop.vue?vue&type=template&id=22f3605f&"
import script from "./StreamBackdrop.vue?vue&type=script&lang=js&"
export * from "./StreamBackdrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports